import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from "react-bootstrap";
import HelperMetiers360 from '../../../services/HelpersMetiers360';
import DynamicTable from "../../widgets/dynamicTable/DynamicTable";
import "./VideoMediasComponent.scss";

const VideoMediasComponent = (props) => {

    const { medias } = props;

    const onDownloadFile = (e, url) => {
        e.stopPropagation();
        window.open(url);
    };

    const sortType = [
        {
            value: 'localName', label: 'Nom',
            test: HelperMetiers360.isArrayContainsValue(medias, "localName"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.localName, b.localName),
            display: (media) => media.localName
        },
        {
            value: 'typeLabel', label: 'Type',
            test: HelperMetiers360.isArrayContainsValue(medias, "typeLabel"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.typeLabel, b.typeLabel),
            display: (media) => media.typeLabel
        },
        {
            value: 'fileSize', label: 'Taille',
            test: HelperMetiers360.isArrayContainsValue(medias, "fileSize"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.fileSize, b.fileSize),
            display: (media) => HelperMetiers360.formatBytes(media.fileSize)
        },
        {
            value: 'hash', label: 'Hash',
            test: HelperMetiers360.isArrayContainsValue(medias, "hash"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.hash, b.hash),
            display: (media) => media.hash
        },
        {
            value: 'videoMediaLink', label: 'Url',
            test: HelperMetiers360.isArrayContainsValue(medias, "videoMediaLink"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.videoMediaLink, b.videoMediaLink),
            display: (media) => media.videoMediaLink
        },
        {
            value: 'createdDate', label: "Date de création",
            test: HelperMetiers360.isArrayContainsValue(medias, "createdAt"),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.createdAt, b.createdAt),
            display: (media) => media.createdAt ?
                HelperMetiers360.getdisplayDateType(media.createdAt, 'day')
                : '-'
        },
        {
            value: 'updatedAt', label: "Date de modification",
            test: HelperMetiers360.isArrayContainsValue(medias, "updatedAt"),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.updatedAt, b.updatedAt),
            display: (media) => media.updatedAt ?
                HelperMetiers360.getdisplayDateType(media.updatedAt, 'day')
                : '-'
        },
        {
            value: 'isPublished', label: "Visible",
            test: HelperMetiers360.isArrayContainsValue(medias, "isPublished"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.isPublished, b.isPublished),
            display: (media) => media.isPublished ? <i className="far fa-eye" /> : "",
            flatDisplay: (media) => media.isPublished ? "Visible" : "Non visible",
        },
        {
            value: 'download', label: "Télecharger",
            test: HelperMetiers360.isArrayContainsValue(medias, "url"),
            display: (media) => <Button
                variant="secondary"
                className="p-2 m-2"
                size="sm"
                onClick={(e) => onDownloadFile(e, media.url)}
            >
                <i className="fas fa-download" />
            </Button>,
            flatDisplay: (media) => media.url,
        },

    ];

    return (medias?.length > 0 ?
        <DynamicTable
            contentTable={medias}
            contentSort={sortType}
            index='uniqueId'
            valueInitSort="updatedAt"
        />
        : <Alert variant="warning">Pas de medias associés à cette expérience</Alert>)

}

VideoMediasComponent.propTypes = {
    medias: PropTypes.array.isRequired
}

export default VideoMediasComponent;